var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgFlagGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "22px",
    viewBox: "0 0 30 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72178850-11E0-4F29-88E9-563DC2BA5F9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stories-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05A---Stories-(On-this-day)",
    transform: "translate(-12.000000, -1248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(12.000000, 1232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "custom-icon-tag-2",
    transform: "translate(15.000000, 26.714286) scale(-1, 1) rotate(-360.000000) translate(-15.000000, -26.714286) translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg-flag",
    fill: "#A38138",
    points: "1.40069504e-13 0 30 0 30 21.4285714 1.40069504e-13 21.4285714 6 10.7142857"
  }), /*#__PURE__*/React.createElement("g", {
    id: "priority_high_black_18dp",
    transform: "translate(8.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 17 0 17 17 0 17"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 8.5,
    cy: 13.4583333,
    r: 1.41666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "7.08333333 2.125 9.91666667 2.125 9.91666667 10.625 7.08333333 10.625"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlagGold);
export default __webpack_public_path__ + "static/media/bg-flag-gold.93b4aa66b92b71ceb49c93f12391a821.svg";
export { ForwardRef as ReactComponent };